"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagKY = function FlagKY(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74-122H-7.53L-72.95-79.14V-122h-35.3v42.86L-173.67-122h-12.27a7.06,7.06,0,0,0-7.06,7.06v5.6l56.12,36.77H-193v35.32h56.12L-193-.48v5.6a7.06,7.06,0,0,0,7.06,7.06h12.27l65.42-42.86V12.18h35.3V-30.68L-7.53,12.18H4.74A7.06,7.06,0,0,0,11.8,5.12V-.48L-44.32-37.25H11.8V-72.57H-44.32L11.8-109.34v-5.6A7.06,7.06,0,0,0,4.74-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-65.5H-80V-122H-101.2v56.5H-193v21.18h91.8v56.5H-80v-56.5H11.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-115.32-72.57l-74.31-48.23a6.94,6.94,0,0,0-3.37,5.86v.37l64.71,42Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-60-72.57l70.7-45.89a7,7,0,0,0-6-3.54H3.21L-72.95-72.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-121.42-37.25-192,8.55a7,7,0,0,0,6,3.63h1.33l76.16-49.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.69,5.67-54.45-37.25h-13L7.68,11.49a7,7,0,0,0,4-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.06-54.84s-3-11.82-11.81-17.73c0,0,8.86,14.77,8.86,26.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M100.4-67.68a29.82,29.82,0,0,1,9.51,10l-2.68,6.19a64.69,64.69,0,0,0-6.83-16.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M93.57-66.29S104.28-63,109.36-56l-3,4.62A52.56,52.56,0,0,0,93.57-66.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92-60.94s11.27,1.76,16.34,7.11l-1.29,5.08A58.21,58.21,0,0,0,92-60.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.38-57.25s10.89,1.11,15.87,6.83-1.85,4-1.85,4a52.62,52.62,0,0,0-14-10.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.06-54.84s3-11.82,11.81-17.73c0,0-8.85,14.77-8.85,26.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M127.72-67.68a29.92,29.92,0,0,0-9.51,10l2.68,6.19a64.69,64.69,0,0,1,6.83-16.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M134.55-66.29S123.84-63,118.77-56l3,4.62a52.56,52.56,0,0,1,12.74-14.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136.12-60.94s-11.26,1.76-16.34,7.11l1.29,5.08a58.21,58.21,0,0,1,15.05-12.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M135.75-57.25s-10.89,1.11-15.88,6.83,1.85,4,1.85,4a52.57,52.57,0,0,1,14-10.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.06-72.57s-3,6.22,0,9.32c3-3.1,0-9.32,0-9.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M111.12-71s-.4,6.87,3.51,8.63c1.57-4-3.51-8.63-3.51-8.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M117-71s.4,6.87-3.5,8.63c-1.57-4,3.5-8.63,3.5-8.63Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M118-67.06s-2.58,6.38-6.86,6.31C111.4-65,118-67.06,118-67.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.15-67.06s2.58,6.38,6.87,6.31c-.29-4.28-6.87-6.31-6.87-6.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M122.92-51.89c0,6.52-4,11.81-8.87,11.81s-8.86-5.29-8.86-11.81,4-11.82,8.86-11.82,8.87,5.29,8.87,11.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd255"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M93.82-39.83l-2-3.14s-5.91,1.41-7.32-3l-2.28-.18s.31-3,3-3.45a5,5,0,0,1,4.43-1.59c2.83.36,4.31,2.76,5.94,3.38a3.29,3.29,0,0,1,1.82,2.64l12.42,12.74s-3.56,4.55-6.76,6-15-5.72-9.17-13.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M134.18-37.5s5.17,3.51,5.36,13.2H131s.09-6.55-1.57-10.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M133.07-37.12s6.47,2.12,10.43-3L136.77-41Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M131.14-44.23,137.69-42a1.21,1.21,0,0,1,.54,2,29.47,29.47,0,0,1-21.89,9.53c-15.6,0-19.63-9.82-19.81-10.55s-1-6.74-1-6.74l6.65-.74Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M67.35,46.12H84.53L75.67,63.28,66.81,51.47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M160.77,46.12H143.59l8.86,17.16,8.86-11.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M67.28,75.1A28.57,28.57,0,0,1,52,70.31l6.83-9.64s5.77,3.92,11.61,2.16,9.78-8.75,12-14.29l11,4.39C88.73,64.57,82.1,71.71,73.67,74.19a22.92,22.92,0,0,1-6.39.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd25a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M160.84,75.1a28.67,28.67,0,0,0,15.3-4.79l-6.83-9.64c-.06,0-5.78,3.92-11.61,2.16s-9.79-8.75-12-14.29l-11,4.39c4.66,11.64,11.29,18.78,19.73,21.26a22.8,22.8,0,0,0,6.38.91Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd25a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M152.45,13.08H75.67V-15.3a7.06,7.06,0,0,1,7.06-7.06h62.66a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.62-1.69l-.92-5.9c-4.34-.19-6.83-5.27-6.83-5.27l-3.51,1.94c3.69,8.86,11.26,9.23,11.26,9.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M142.86-7.78A11.12,11.12,0,0,1,147-9.13a3.33,3.33,0,0,0-4.25-.62,3.88,3.88,0,0,0,.8-4.18c0,.8-1.29,1.35-1.29,1.35.06-1.6-1.6-3.13-1.6-3.13l-.86,1.41a6.25,6.25,0,0,0-2.52-2.4l-.8,3.32c-1.85-1.6-5.11-1.48-5.11-1.48l.61,1.54c-2,.07-7.32,1.17-10.45,1.54s-5.66-.49-5.66-1.9c0-1.19,2.74-1.34,3.92-1.36.84.19,1.9.5,3.38.94a5.12,5.12,0,0,0,4.39-.37c-1-.37-1.08-.8-1.08-.8a6.79,6.79,0,0,1,4-.91c-.69-1.52-3.69-1.43-3.69-1.43a4.32,4.32,0,0,0,1.38-1.7,16.52,16.52,0,0,1-4.22.91,8.49,8.49,0,0,0-4.07,2.19c-1.85-.15-6.68-.2-5.83,3.14,1,4.12,9.35,2.65,14.46,1.85s7.75-.12,8.86.55-.47,3-5.66,2a31.06,31.06,0,0,0-8.31-.69,23.36,23.36,0,0,0-3.69.69c-2,.43-9.84,3.2-11.32-.8s-8.67,6.52-8.67,6.52l.56.67L98.37-2.7C95.79.76,88,1.82,88,1.82S86.88-.25,85.91-.53,84.53.71,84.53.71a1.3,1.3,0,0,0-1.25,1.11A1,1,0,0,0,84.11,3S83,4.59,84.85,5.05c0,0-.14,2.26,2.58.69A21.09,21.09,0,0,0,104,.34a12.57,12.57,0,0,0,6.28-1c3.19-1.66,6.89-3.75,9-2.95,0,0,1.72,5.29-5,5.41,0,0-1-1.27-2-1.27a.83.83,0,0,0-.75,1s-1.18-.06-1.39.63.24,1.22,1.11,1.11c0,0-.59.87,0,1.39a1.11,1.11,0,0,0,1.32,0s-.31,1.08.42,1.18,1.45-.93,1.69-1.24c1.08.17,8.47,1,10.06-6.73A17.5,17.5,0,0,0,132-.83c3.63-.3,7.2.25,6.89,2-.4,1.3-1.2,1.21-1.2,1.21-.87-.35-2.33-.31-2.53.94s1.49,1.29,1.49,1.29c.48,1.14,1.87.66,1.87.66a1.46,1.46,0,0,0,2-.07,1.09,1.09,0,0,0,1.56.1c.49-.42.22-3.2.17-4.19-.08-1.65-.31-6-2.71-6s-5.47,1.35-9.72-2.21c-.22-.19-.44-.31-.66-.47,2,.19,3.45.73,4.85,1,1.9.31,7.5-.18,8.8-1.17Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.36-10.91A7.8,7.8,0,0,1,83.61-11a1.12,1.12,0,0,1,0-2.13S82.28-14,82.87-15A1.43,1.43,0,0,1,85-15.34s-.39-1.29.73-1.71c.9-.34,1.62.69,1.62,2,0,0,1.34-1.09,2-.37.48.5.34,1.16-.46,2.53s-3.51,1.95-3.51,1.95Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M83.9-11.48s-.62,1.07-2.43.41c0,0,1.56-.73,1.77-1.36Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M83.24-14.65a4.1,4.1,0,0,0-2-.59,2.6,2.6,0,0,1,3-.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.5-16.32a2,2,0,0,0-.31-1.77s1.29.56,1.46,1.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M88.35-15.13s.63-1.39.07-2a2.1,2.1,0,0,1,1,2.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.1.31S84.43-1.06,83.57-1a2.1,2.1,0,0,1,2.59.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M83.63,2.05s-1.19-.95-2-.57a2.11,2.11,0,0,1,2.73-.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M84.47,4.51s-1.52,0-1.9.76c0,0,.22-1.92,2-1.92Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.86,6.09s-.62,1.08-2.43.42c0,0,1.57-.73,1.77-1.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M113.33,5.55s-.52.88-2,.34c0,0,1.2-.43,1.37-.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M97.69-13.5A24.69,24.69,0,0,0,95.17.34a19.46,19.46,0,0,0,14-11.21,2.88,2.88,0,0,0,1.45-1.42c.34-.86.31-2.26-1.34-2.26,0,0,.5-1,1.09-1.21a4.27,4.27,0,0,0-2.3-.14,3.54,3.54,0,0,0,1-2.22,7.44,7.44,0,0,1-2.4,1.07s-.09-1.53.28-1.71a5.35,5.35,0,0,0-2.91,1.2,3.22,3.22,0,0,1-.6-1.8A6.31,6.31,0,0,0,101-17.43a1.86,1.86,0,0,1-.51-1.19,12,12,0,0,0-1.57,2.39,1.57,1.57,0,0,0-1.75.65,1.48,1.48,0,0,0,.56,2.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd255"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M111.85,1.43a2.08,2.08,0,0,0-1.58-.91,2.31,2.31,0,0,1,2.46.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M136.27,4.24A2.25,2.25,0,0,0,135,5.73a2.47,2.47,0,0,1,.8-2.54Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M138.09,4.88A2.94,2.94,0,0,0,137.31,7a2.48,2.48,0,0,1-.12-2.67Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M142,4.81a2,2,0,0,0,.5,1.74s-1.55-.5-1.58-1.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M140.16,5.14a2.21,2.21,0,0,0-.48,1.9,1.94,1.94,0,0,1-.47-2.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M110.59,3a2,2,0,0,0-1.77.39s.64-1.53,2-1.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M111.67,4.62a2.08,2.08,0,0,0-1.73.55,1.61,1.61,0,0,1,1.52-1.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M152.45,17.84c-6.4,0-6.4,5.77-12.81,5.77s-6.4-5.77-12.8-5.77-6.4,5.77-12.8,5.77-6.4-5.77-12.79-5.77-6.39,5.77-12.79,5.77-6.39-5.77-12.79-5.77V7.17c6.4,0,6.4,5.78,12.79,5.78s6.4-5.78,12.79-5.78S107.64,13,114,13s6.4-5.78,12.8-5.78,6.4,5.78,12.8,5.78,6.41-5.78,12.81-5.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M139.64,23.61c-6.4,0-6.4-5.77-12.8-5.77s-6.4,5.77-12.8,5.77-6.4-5.77-12.79-5.77-6.39,5.77-12.79,5.77-6.4-5.74-12.75-5.77a82.59,82.59,0,0,0,1.13,10.8c5.19.69,5.66,5.64,11.62,5.64,6.4,0,6.4-5.78,12.79-5.78s6.39,5.78,12.79,5.78,6.39-5.78,12.8-5.78,6.4,5.78,12.8,5.78c6,0,6.45-5,11.64-5.64a82.59,82.59,0,0,0,1.13-10.8c-6.36,0-6.38,5.77-12.77,5.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M139.64,34.28c-6.4,0-6.4-5.78-12.8-5.78s-6.4,5.78-12.8,5.78-6.4-5.78-12.79-5.78-6.39,5.78-12.79,5.78c-6,0-6.43-5-11.62-5.64a81.4,81.4,0,0,0,2.78,11.53C82.5,41.83,83.75,45,88.46,45c6.4,0,6.4-5.78,12.79-5.78S107.64,45,114,45s6.4-5.78,12.8-5.78,6.4,5.78,12.8,5.78c4.72,0,6-3.13,8.86-4.78a81.84,81.84,0,0,0,2.79-11.53c-5.2.69-5.68,5.64-11.65,5.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M139.64,45c-6.4,0-6.4-5.78-12.8-5.78S120.44,45,114,45s-6.4-5.78-12.79-5.78S94.86,45,88.46,45c-4.71,0-6-3.13-8.84-4.78a63.79,63.79,0,0,0,7.09,15.24,8.42,8.42,0,0,0,1.75.2c6.4,0,6.4-5.78,12.79-5.78s6.39,5.78,12.79,5.78,6.4-5.78,12.8-5.78,6.4,5.78,12.8,5.78a8.54,8.54,0,0,0,1.77-.2,63.41,63.41,0,0,0,7.09-15.24c-2.88,1.65-4.14,4.78-8.86,4.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M139.64,55.61c-6.4,0-6.4-5.78-12.8-5.78s-6.4,5.78-12.8,5.78-6.4-5.78-12.79-5.78-6.39,5.78-12.79,5.78a8.42,8.42,0,0,1-1.75-.2A48.49,48.49,0,0,0,94,64.17c2-1.65,3.5-3.67,7.29-3.67,6.39,0,6.39,5.78,12.79,5.78s6.4-5.78,12.8-5.78c3.8,0,5.35,2,7.32,3.68a48.62,48.62,0,0,0,7.25-8.77,8.54,8.54,0,0,1-1.77.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M134.16,64.18c-2-1.66-3.52-3.68-7.32-3.68-6.4,0-6.4,5.78-12.8,5.78s-6.4-5.78-12.79-5.78c-3.79,0-5.34,2-7.3,3.67A44.36,44.36,0,0,0,114.06,75.1a44.31,44.31,0,0,0,20.1-10.92Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M126.84,7.17c-6.4,0-6.4,5.78-12.8,5.78s-6.4-5.78-12.79-5.78S94.86,13,88.46,13,82.07,7.17,75.67,7.17V16c0,.5,0,1.12,0,1.81,6.36,0,6.38,5.77,12.76,5.77s6.4-5.77,12.79-5.77,6.39,5.77,12.79,5.77,6.39-5.77,12.8-5.77,6.4,5.77,12.8,5.77,6.41-5.74,12.78-5.77c0-.7,0-1.31,0-1.81V7.17c-6.4,0-6.4,5.78-12.81,5.78s-6.4-5.78-12.8-5.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M149.5-22.36a3,3,0,0,1,2.95,2.95V16c0,.5,0,1.11,0,1.81a86.26,86.26,0,0,1-1.13,10.8,83.48,83.48,0,0,1-2.78,11.53,63.6,63.6,0,0,1-7.1,15.23,48.68,48.68,0,0,1-7.25,8.78,44.15,44.15,0,0,1-20.1,10.91A44.18,44.18,0,0,1,94,64.16a48.22,48.22,0,0,1-7.25-8.76,63.94,63.94,0,0,1-7.09-15.23,83.48,83.48,0,0,1-2.78-11.53,84.39,84.39,0,0,1-1.13-10.8c0-.7,0-1.31,0-1.81V-19.41a3,3,0,0,1,3-2.95H149.5m0-2.21H78.62a5.17,5.17,0,0,0-5.17,5.16V16c0,.52,0,1.17,0,1.89A84.54,84.54,0,0,0,74.65,29a86,86,0,0,0,2.86,11.84,65.69,65.69,0,0,0,7.34,15.76,50.21,50.21,0,0,0,7.58,9.16,46.61,46.61,0,0,0,21.09,11.48l.54.13.54-.13a46.78,46.78,0,0,0,21.08-11.46,51.15,51.15,0,0,0,7.59-9.18,65.76,65.76,0,0,0,7.34-15.77A85.28,85.28,0,0,0,153.47,29a84.26,84.26,0,0,0,1.16-11.08c0-.72,0-1.37,0-1.89V-19.41a5.17,5.17,0,0,0-5.17-5.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.06,57.24,106,62.88l2.86-9.45-7.87-6,9.87-.2,3.24-9.33,3.24,9.33,9.87.2-7.86,6,2.86,9.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M114.06,39.76l2.81,8.09,8.57.17-6.83,5.18,2.48,8.2-7-4.89-7,4.89,2.48-8.2L102.68,48l8.57-.17,2.81-8.09m0-3.65-1.13,3.25-2.54,7.31-7.73.16-3.44.07L102,49l6.16,4.67-2.24,7.41-1,3.29,2.82-2L114.06,58l6.35,4.42,2.82,2-1-3.29L120,53.65,126.16,49l2.75-2.08-3.45-.07-7.73-.16-2.54-7.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.27,34.2l-8.11,5.64L91,30.39l-7.87-6,9.87-.2,3.25-9.33,3.23,9.33,9.87.2-7.86,6,2.86,9.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M96.27,16.72l2.81,8.09,8.56.18-6.82,5.17,2.48,8.2-7-4.89-7,4.89,2.48-8.2L84.89,25l8.56-.18,2.82-8.09m0-3.64-1.14,3.25-2.54,7.31-7.73.15-3.44.07,2.74,2.08,6.16,4.68L88.09,38l-1,3.3,2.82-2,6.36-4.42,6.34,4.42,2.83,2-1-3.3-2.24-7.4,6.17-4.68,2.74-2.08-3.44-.07-7.74-.15-2.54-7.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M131.7,34.2l-8.1,5.64,2.86-9.45-7.87-6,9.87-.2,3.24-9.33L135,24.23l9.86.2-7.86,6,2.85,9.45Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M131.7,16.72l2.82,8.09,8.56.18-6.83,5.17,2.48,8.2-7-4.89-7,4.89,2.48-8.2L120.32,25l8.57-.18,2.81-8.09m0-3.64-1.13,3.25L128,23.64l-7.73.15-3.44.07,2.74,2.08,6.17,4.68L123.52,38l-1,3.3,2.82-2,6.35-4.42,6.35,4.42,2.82,2-1-3.3-2.24-7.4,6.16-4.68,2.75-2.08-3.44-.07-7.74-.15-2.54-7.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M160.77,46.12a50.13,50.13,0,0,1-93.42,0l-11,4.3a61.93,61.93,0,0,0,115.4,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M120-22.36h-8.86l-3-8.86H117Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M134.73-22.36h-5.9l-2-5.91h2.69a4.45,4.45,0,0,1,4.23,3.05Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M102.25-22.36H96.34l-.67-2a3,3,0,0,1,2.8-3.89h1.81Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M128.83-22.36H120l-3-8.86h6.73a3,3,0,0,1,2.8,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M111.11-22.36h-8.86l-2-6a2.19,2.19,0,0,1,2.08-2.88h5.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M135.75-42.85c-2.31,3.32-8.77,7.29-19.29,7.29a22,22,0,0,1-16.1-7.3,2.66,2.66,0,0,1-.7-1.82v-2a2.42,2.42,0,0,1,1.2-2.1c1.88-1.08,6.21-2.83,14.77-2.83,10.61,0,20.12,8.77,20.12,8.77Zm0,0",
    transform: "translate(194 123)",
    fill: "#509664"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagKY;
exports["default"] = _default;